import React from 'react';
import NavigationAnchor from '../../User/NavigationAnchor';
import RegistrationModalAnchors from './RegistrationModal/RegistrationModalAnchors';
import './anonymousHeader.less';
import './../../AppHeader/appHeader.less';
import RegistrationModal from './RegistrationModal/RegistrationModal';
import { getRegistrationModalTitle } from '../util';

export default function AnonymousHeader(): JSX.Element {
	const [isVisible, setIsVisible] = React.useState(false);
	const [type, setType] = React.useState<string>('');

	const handleClick = (currentType: string) => {
		setIsVisible(true);
		setType(currentType);
	};

	return (
		<div className="app-header anonymous-header">
			<NavigationAnchor />
			<div className="modal-container">
				<RegistrationModalAnchors handleClick={handleClick} />
				<RegistrationModal
					modalTitle={getRegistrationModalTitle(type)}
					setType={setType}
					type={type}
					setIsVisible={setIsVisible}
					isVisible={isVisible}
				/>
			</div>
		</div>
	);
}
